export default __webpack_public_path__ + "2d4b477bc424d35a0245eb54b3b4d450.svg";